import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { LocalRepository } from '@shared/helper/local-repository';
import { HttpTransportType, HubConnection, HubConnectionBuilder, HubConnectionState, IHttpConnectionOptions, LogLevel } from '@microsoft/signalr';
import { ACCESS_TOKEN_KEY } from 'constants/storage-keys';

@Injectable({
  providedIn: 'root',

})
export class SignalHubService {
  private _localRepository = inject(LocalRepository);

  private signalRConnection!: HubConnection;
  private connectedAsync$: BehaviorSubject<HubConnection | null> = new BehaviorSubject<signalR.HubConnection | null>(null);
  public connectedSubscribtion = this.connectedAsync$.asObservable();

  constructor() {

    if(this._localRepository.IsInBrowser) {
      this.buildSingalConnection();
      this.startConnection();
      this.connectedSubscribtion.subscribe();
    }
  }

  private buildSingalConnection() {
    if (this._localRepository.IsInBrowser && this._localRepository.getCookieItem(ACCESS_TOKEN_KEY)) {
      this.signalRConnection = new HubConnectionBuilder()
        .configureLogging(LogLevel.Error)
        .withUrl(`${environment.SocketUrl}/booxell`, {
          accessTokenFactory: () => this._localRepository.getCookieItem(ACCESS_TOKEN_KEY),
          transport: HttpTransportType.WebSockets,
          skipNegotiation: false
        } as IHttpConnectionOptions)
        .withAutomaticReconnect()
        .build();
    }
  }

  startConnection() {
    console.log('start signal connection...');

    if (!this._localRepository.IsInBrowser)
      return;
    const onRetry = () => {
      console.error(`signal is reconnecting... `);
      onRetryConnected()
    };
    const onClosed = () => {
      console.error(`signal connection closed. try reconnect... `);

      onRetry();
    };
    const onErrorCatch = () => {
      console.error(`signal connection interupted and failed. try reconnect... `);

      onRetry();
    };
    const onConnected = () => {
      this.signalRConnection.invoke("OnConnected").then(() => {
        this.connectedAsync$.next(this.signalRConnection);
      })
        .catch((resons) => {
          console.error(`signal are could not invoik OnConnected method`, resons);
        });
    };
    const onRetryConnected = (): void => {
      console.log('reconnected');
    };

    if (!this.signalRConnection)
      this.buildSingalConnection();
    if (!this._localRepository.IsInBrowser || !this._localRepository.getCookieItem(ACCESS_TOKEN_KEY))
      return;
    this.signalRConnection.onclose(onClosed);
    this.signalRConnection.onreconnecting(onRetry);
    this.signalRConnection.onreconnected(onRetryConnected);

    if (this._localRepository.getCookieItem(ACCESS_TOKEN_KEY)) {
      if (this.IsConnected)
        console.info(`signalr is already connected`);

      if (!this.IsConnected)
        this.signalRConnection.start()
          .then(() => {
            onConnected();
          })
          .catch(onErrorCatch)
    }
  }

  public get Connection(): Observable<signalR.HubConnection | null> {
    return this.connectedSubscribtion;
  }

  public get IsConnected(): boolean {
    if (this._localRepository.IsInBrowser && this.signalRConnection) {
      return this.signalRConnection.state == HubConnectionState.Connected;
    }
    return false;
  }

}
